import { render, staticRenderFns } from "./ThgSuccessCard.vue?vue&type=template&id=4f94865d"
import script from "./ThgSuccessCard.vue?vue&type=script&lang=ts"
export * from "./ThgSuccessCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports